import logo from "@/assets/logo.svg";

type Config = {
  environment: "local" | "development" | "production";
  appSecret: string;
  baseUrl: string;
  googleReCaptchaSiteKey: string;
  googleAuthClientId: string;
  facebookAuthAppId: string;
  logoUrl: string;
  brandName: string;
  clarityId: string | undefined;
};

export const config: Config = {
  environment:
    (import.meta.env.VITE_ENVIRONMENT as "local" | "development" | "production") ||
    "local",
  appSecret: (import.meta.env.VITE_APP_SECRET as string) || "secret",
  baseUrl: (import.meta.env.VITE_BASE_URL as string) || "http://localhost:3000",
  googleReCaptchaSiteKey:
    (import.meta.env.VITE_RECAPTCHA_SITE_KEY as string) || "aaa",
  googleAuthClientId:
    (import.meta.env.VITE_GOOGLE_AUTH_CLIENT_ID as string) || "aaa",
  facebookAuthAppId:
    (import.meta.env.VITE_FACEBOOK_AUTH_APP_ID as string) || "aaa",
  logoUrl: (import.meta.env.VITE_LOGO_URL as string) || logo,
  brandName: (import.meta.env.VITE_BRAND_NAME as string) || "SoulHub",
  clarityId: import.meta.env.VITE_CLARITY_ID as string | undefined,
};

/** Marca do painel white-label (alinha com header `x-brand` enviado pelo customFetch). */
export type PanelBrandSlug = "soulhub" | "infinity";

/**
 * Preferência explícita em deploy (evita ambiguidade quando `VITE_BRAND_NAME`
 * contém "infinity" mas o build é SoulHub, ou o contrário).
 */
export function getPanelBrandSlug(): PanelBrandSlug {
  const explicit = (
    import.meta.env.VITE_PANEL_BRAND as string | undefined
  )
    ?.trim()
    .toLowerCase();
  if (explicit === "infinity" || explicit === "soulhub") {
    return explicit;
  }

  const name = (config.brandName || "").toLowerCase();
  if (name.includes("soulhub")) {
    return "soulhub";
  }
  if (name.includes("infinity")) {
    return "infinity";
  }
  return "soulhub";
}
